import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalProvider } from './Context/GlobalContext';
import { HashRouter } from 'react-router-dom';

// Pick the favicon and document title based on the company. Company "0it02f"
// (4Life) uses favicon4life.ico and the "Healthy 4Life Scan" title; every other
// company falls back to the default favicon.ico and title.
(() => {
  const is4Life = process.env.REACT_APP_COMPANY_ID === '0it02f';
  const favicon = is4Life ? 'favicon4life.ico' : 'favicon.ico';
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = `${process.env.PUBLIC_URL || ''}/${favicon}`;

  if (is4Life) {
    document.title = 'Healthy 4Life Scan';
  }
})();

// The app uses HashRouter, so client routes live after "#". A clean campaign
// link like /campaign/:code (generated by the backend) has no hash and would
// otherwise fall back to "/". Rewrite it to the hash route before React mounts.
(() => {
  const { pathname, search, hash } = window.location;
  if (!hash && /^\/campaign\/[^/]+/.test(pathname)) {
    window.location.replace(`${window.location.origin}/#${pathname}${search}`);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <GlobalProvider>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </GlobalProvider>
  </HashRouter>
);

reportWebVitals();
